(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-gallery-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  const getHeaderOffset = () => {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'), 10) || 0;
  };

  const scrollToElement = (element) => {
    if (!element) return false;

    const targetTop = element.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 24;
    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });

    return true;
  };

  const scrollToTargetId = (targetId) => {
    const target = document.getElementById(targetId);
    return scrollToElement(target);
  };

  const scrollToNextCustomLiquid = (sectionEl) => {
    let wrapper = sectionEl.closest('.shopify-section');
    while (wrapper && wrapper.nextElementSibling) {
      wrapper = wrapper.nextElementSibling;
      const customLiquid = wrapper.querySelector('.section-custom-liquid');
      if (customLiquid) {
        return scrollToElement(customLiquid);
      }
    }

    return false;
  };

  const waitAndScrollToTarget = (targetId, sectionEl) => {
    if (scrollToTargetId(targetId)) return;

    scrollToNextCustomLiquid(sectionEl);

    const maxWaitMs = 15000;
    const startTime = Date.now();

    let timer;
    const cleanup = (observerInstance) => {
      observerInstance.disconnect();
      if (timer) {
        clearInterval(timer);
      }
    };

    const observer = new MutationObserver(() => {
      if (scrollToTargetId(targetId)) {
        cleanup(observer);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    timer = setInterval(() => {
      if (scrollToTargetId(targetId)) {
        cleanup(observer);
        return;
      }

      if (Date.now() - startTime >= maxWaitMs) {
        cleanup(observer);
      }
    }, 250);
  };

  const bindSectionScroll = (sectionEl) => {
    const button = sectionEl.querySelector('.pdp-gallery-content__button[data-scroll-target-id]');
    if (!button || button.dataset.scrollBound === 'true') return;

    button.dataset.scrollBound = 'true';
    button.addEventListener('click', (event) => {
      const targetId = button.dataset.scrollTargetId;
      if (!targetId) return;
      event.preventDefault();
      waitAndScrollToTarget(targetId, sectionEl);
    });
  };

  const init = () => {
    document.querySelectorAll('.section-pdp-gallery-content').forEach(bindSectionScroll);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
